import React, { useState, useEffect, lazy, Suspense } from "react";
import { Helmet } from 'react-helmet';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CarLoader from "../../Components/PageLoader/CarLoader/CarLoader";
import Header from "../../Components/Header/Header";
import HomePageBanner from "./HomePageBanner";
import { SectionSkeleton } from "../../Components/Skeleton";
import { useLang } from "../../Utility/hooks/useLang";
import "./LandingPage.scss";
import SeoHelmet from "../../Components/SEO/SeoHelmet";
import { organizationSchema, websiteSchema } from "../../Utility/schema";

import SectionTwo from "./SectionTwo";
import SectionThree from "./SectionThree";
import SectionFour from "./SectionFour";
import Footer from "../../Components/Footer/Footer";

const LandingPage = () => {
  const navigate = useNavigate();
  const { lang, setLang } = useLang();
  // const [lang, setLang] = useState(
  //   sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  // );
  const { t, i18n } = useTranslation();
  const isArabic = lang === "ar";
  const isArabicLang = lang === "ar";
  const [activeTab, setActiveTab] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const langChange = (e) => {
    const selectedLang = e.target.checked ? "ar" : "en";
    sessionStorage.setItem("lang", selectedLang);
    setLang(selectedLang);
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const HelpModalOpenModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <SeoHelmet
        lang={isArabic ? "ar" : "en"}
        title={isArabic ? "قارن التأمين في عُمان بسهولة وسرعة عبر الإنترنت | Tameen" : "Compare Insurance Online in Oman Fast and Easy | Tameen"}
        description={
          isArabic ?
            "اكتشف مستقبل التأمين في عُمان عبر منصة تأمين، حيث يلتقي الابتكار بالموثوقية. قارن واشترِ التأمين على السيارات والصحة والسفر والممتلكات بسهولة."
            :
            "Experience the future of insurance with Tameen.om, where innovation meets reliability. Compare and buy car, health, travel, and property insurance easily."
        }
        keywords={isArabic ?
          "تأمين السيارات, تأمين السفر, التأمين الصحي, تأمين المنازل, تأمين عمان"
          :
          "Motor Insurance Oman, Travel Insurance Oman, Health Insurance Oman, Home Insurance Oman"
        }
        image="https://storage.tameen.om/tameen/newtm/tameen_newlogo.webp"
        schema={[organizationSchema, websiteSchema]}
      />
      {loading ? (
        <CarLoader />
      ) : (
        <main className="staticMain">
          <Header />
          {/* HOME PAGE BANNER STARTS HERE */}
          <HomePageBanner />
          {/* HOME PAGE BANNER ENDS HERE */}
          {/* HOME SECTION TWO STARTS HERE */}
          <SectionTwo />
          {/* HOME SECTION TWO ENDS HERE */}
          {/* HOME SECTION THREE STARTS HERE */}
          <SectionThree lang={lang} />
          {/* HOME SECTION THREE ENDS HERE */}
          {/* HOME SECTION FOUR STARTS HERE */}
          <SectionFour />
          {/* HOME SECTION FOUR ENDS HERE */}
          {/* FOOTER SECTION FOUR STARTS HERE */}
          <Footer />
          {/* FOOTER SECTION FOUR ENDS HERE */}
        </main>
      )}
    </div>
  );
};

export default LandingPage;
